var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"auto-refinements\" ing-transclude=\"refinements\"><a href class=\"auto-refinement\" ng-click=\"$ctrl.query.clearRefinements(true)\" ng-show=\"$ctrl.query.refinements.length\"><span class=\"label label-primary\">Clear All Filters </span></a><a href ng-repeat=\"r in $ctrl.query.refinements\" class=\"auto-refinement\" ng-click=\"r.remove()\"><span class=\"label\">{{::r.label}} <span>x</span></span></a></div>";
var id1="auto-query-refinements-bar.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;